import { createClient } from "@supabase/supabase-js";

const options = {
  auth: {
    localStorage: true,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
};

const supabaseUrl = "https://xuoohsncmnzqgjytndsy.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh1b29oc25jbW56cWdqeXRuZHN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkzMjQyMzMsImV4cCI6MjA2NDkwMDIzM30.iFFEI50G7K4k9n3mGRzohh3F-dORxloxPC5TvFS6uoU";

const supabase = createClient(supabaseUrl, supabaseAnonKey, options);

export default supabase
